/*
 * @Description:
 * @Date: 2024-12-12 11:54:05
 */
import TaxAuthRedirect from '../views/tax-auth-redirect.vue';

export const route = [
  {
    path: '/tax-auth',
    component: TaxAuthRedirect,
    meta: {
      title: '授权'
    }
  }
];
